import { useState, useCallback } from "react";
import { getUserId } from "../utils/Auth";
import API_BASE_URL from "../config";

const useOffersData = () => {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const userId = getUserId();

  // 🔥 API hívás az ajánlatok lekérésére
  const fetchOffers = useCallback(async (year = null) => {
    if (!userId) return;

    setLoading(true);
    try {
      const token = localStorage.getItem("token");

            const query = year ? `?year=${year}` : "";

      const response = await fetch(
        `${API_BASE_URL}/api/offers/my-offers${query}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (!response.ok) {
        throw new Error("⚠️ Hiba az ajánlatok betöltésekor.");
      }

      const data = await response.json();
      setOffers(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [userId]);

  // 🔥 API hívás az ajánlat törlésére
  const deleteOffer = async (offerId) => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${API_BASE_URL}/api/offers/${offerId}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });

      if (!response.ok) throw new Error("Hiba az ajánlat törlésekor.");

    } catch (error) {
      console.error("❌ Hiba az ajánlat törlésekor:", error);
    }
  };

  // 🔥 API hívás új ajánlat hozzáadására
  const addOffer = async (offerData) => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(`${API_BASE_URL}/api/offers`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(offerData),
      });

      if (!response.ok) throw new Error("Hiba az ajánlat létrehozásakor.");

    } catch (error) {
      console.error("❌ Hiba az ajánlat hozzáadásakor:", error);
    }
  };

  const updateOffer = async (offerData) => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        `${API_BASE_URL}/api/offers/${offerData.id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(offerData),
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Hiba az ajánlat frissítésekor.");
      }

    } catch (error) {
      console.error("❌ Hiba az ajánlat frissítésekor:", error);
    }
  };

  const fetchAllOffers = useCallback(async (year = null) => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");

            const query = year ? `?year=${year}` : "";

    const response = await fetch(
        `${API_BASE_URL}/api/offers/all${query}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (!response.ok) {
        throw new Error("⚠️ Hiba az összes ajánlat betöltésekor.");
      }

      const data = await response.json();
      setOffers(data); // 📌 Az összes ajánlatot elmentjük
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  const toggleOfferStatus = async (
    offerId,
    newStatus,
    refusalReason = null
  ) => {
    const token = localStorage.getItem("token");
    await fetch(`${API_BASE_URL}/api/offers/${offerId}/status`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        status: newStatus,
        refusalReason: refusalReason, // 💥 csak akkor lesz ott, ha kell
      }),
    });
  };

  return {
    offers,
    fetchAllOffers,
    fetchOffers,
    deleteOffer,
    addOffer,
    updateOffer,
    loading,
    error,
    toggleOfferStatus,
  };
};

export default useOffersData;
